module.exports = "<div data-bind=\"foreach:items\">\n  <div data-bind=\"style: $parent.style,\n  dragZone:{\n    name: $parent.name\n  }\">\n    <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/dragable/dragablelist/index.html
// module id = 512
// module chunks = 0